
import axios from "axios";
import { URL_BASE } from "../config/url-server";

const clientId = localStorage.getItem("client")
const accessToken = localStorage.getItem("token")



export const getFarm = async (farmId) => {
  const config = { headers: { client: clientId, Authorization: `Bearer ${accessToken}` } };
  try {
    const response = await axios.get(URL_BASE + "farm/get/" + farmId, config)
    const farm = response.data?.data || null;
    return farm;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};



export const getList = async () => {
  const config = { headers: { client: clientId, Authorization: `Bearer ${accessToken}` } };
  try {
    const response = await axios.get(URL_BASE + "farm/list", config);
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};



export const getListAndHectares = async () => {
  const config = { headers: { client: clientId, Authorization: `Bearer ${accessToken}` } };
  try {
    const response = await axios.get(URL_BASE + "farm/list", config);
    const listado = response?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};





export const insert = async (data) => {
  const config = { headers: { client: clientId, Authorization: `Bearer ${accessToken}` } };
  try {
    const response = await axios.post(URL_BASE + "farm/insert", data, config)
    const success = response.data?.success || null;
    return success;
  } catch (error) {
    console.error("Error:", error);
    return false;
  }
};


export const update = async (data) => {
  const config = { headers: { client: clientId, Authorization: `Bearer ${accessToken}` } };
  try {
    const response = await axios.post(URL_BASE + "farm/update", data, config)
    const success = response.data?.success || null;
    return success;
  } catch (error) {
    console.error("Error:", error);
    return false;
  }
};

export const deleteFarm = async (data) => {
  const config = { headers: { client: clientId, Authorization: `Bearer ${accessToken}` } };
  try {
    const response = await axios.post(URL_BASE + "farm/delete-farm", data, config)
    const responseData = response.data;
    return responseData;
  } catch (error) {
    console.error("Error :", error);
    return null;
  }
};



export default {
  getFarm,
  getList,
  insert,
  update,
  getListAndHectares,
  deleteFarm
}

